import styled from 'styled-components';
import { Button } from 'antd';

/* ── Page ── */

export const PageWrapper = styled.div`
  padding: 0;
`;

export const AddButton = styled(Button)`
  background-color: #2d6cca !important;
  border-color: #2d6cca !important;
  color: #ffffff !important;
  &:hover {
    background-color: #1e4d8f !important;
    border-color: #1e4d8f !important;
    color: #ffffff !important;
  }
`;

export const ActionIconButton = styled.button<{ iconColor?: string }>`
  align-items: center;
  border: 1px solid #eee;
  border-radius: 10px;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 8px;
  width: 30px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  background: transparent;

  svg {
    transition: color 0.2s;
  }

  &:hover {
    background-color: ${({ iconColor }) =>
      iconColor === '#f5222d' ? 'rgba(245, 34, 45, 0.1)' : 'rgba(45, 108, 202, 0.1)'} !important;

    svg {
      color: ${({ iconColor }) => iconColor || '#2D6CCA'} !important;
    }
  }
`;

export const DrawerContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

/* ── Search ── */

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

/* ── Category list (kept as a draggable list, not an antd Table, so the
   framer-motion Reorder drag-to-reorder behavior is preserved exactly) ── */

export const ListWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EmptyState = styled.div<{ $isDark?: boolean }>`
  padding: 48px 16px;
  text-align: center;
  color: ${({ $isDark }) => ($isDark ? '#888' : '#999')};
  background: ${({ $isDark }) => ($isDark ? '#1a202c' : '#fafafa')};
  border-radius: 12px;
`;

export const CategoryRow = styled.div<{ $isDark?: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  min-height: 116px;
  background: ${({ $isDark }) => ($isDark ? '#1a202c' : '#ffffff')};
  border: 1px solid ${({ $isDark }) => ($isDark ? '#2d3748' : '#f0f0f0')};
  border-radius: 12px;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
  cursor: grab;

  &:hover {
    border-color: #2d6cca;
    box-shadow: 0 2px 10px rgba(45, 108, 202, 0.08);
  }

  &:active {
    cursor: grabbing;
  }
`;

export const RowThumbnailWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 88px;
  height: 88px;
`;

export const RowThumbnailImg = styled.img`
  width: 88px;
  height: 88px;
  border-radius: 10px;
  object-fit: cover;
  display: block;
`;

export const NoImagePlaceholder = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 10px;
  background: #f5f5f5;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c0c0;
  flex-shrink: 0;
`;

export const RowBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const CategoryNameText = styled.span<{ $isDark?: boolean }>`
  font-weight: 600;
  font-size: 16px;
  color: ${({ $isDark }) => ($isDark ? '#f1f5f9' : '#1a1a1a')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusTag = styled.span<{ $isDark?: boolean }>`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  background: ${({ $isDark }) => ($isDark ? 'rgba(96,165,250,0.12)' : '#e6f7ff')};
  border: 1px solid ${({ $isDark }) => ($isDark ? 'rgba(96,165,250,0.3)' : '#91d5ff')};
  color: ${({ $isDark }) => ($isDark ? '#60a5fa' : '#0958d9')};
`;

export const AddItemsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border-radius: 8px;
  border: 1px solid #2d6cca;
  background: transparent;
  color: #2d6cca;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(45, 108, 202, 0.08);
  }
`;

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`;

export const PreviewImg = styled.img`
  max-width: 80vw;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
`;

/* ── Form Modal ── */

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ModalScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px 8px;
`;

export const ModalFooter = styled.div<{ $isDark: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  border-top: 1px solid ${({ $isDark }) => ($isDark ? '#434343' : '#f0f0f0')};
  background: ${({ $isDark }) => ($isDark ? '#1a202c' : '#ffffff')};
  flex-shrink: 0;
`;

export const CancelButton = styled(Button)`
  min-width: 100px;
`;

export const FormSubmitButton = styled(AddButton)`
  min-width: 130px;
  font-weight: 600;
`;

export const FormField = styled.div`
  margin-bottom: 18px;
`;

export const FormLabel = styled.label<{ $isDark?: boolean }>`
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 13px;
  color: ${({ $isDark }) => ($isDark ? '#a0a0a0' : '#555')};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FormSectionTitle = styled.div<{ $isDark?: boolean }>`
  font-size: 11px;
  font-weight: 600;
  color: ${({ $isDark }) => ($isDark ? '#a0a0a0' : '#555')};
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 12px;
`;

export const RequiredMark = styled.span`
  color: #ff4d4f;
  margin-left: 2px;
  font-weight: 700;
`;

export const FieldError = styled.span`
  font-size: 12px;
  color: #ff4d4f;
  display: block;
  margin-top: 4px;
`;

export const FormDivider = styled.hr<{ $isDark: boolean }>`
  margin: 16px 0;
  border: 0;
  border-top: 1px solid ${({ $isDark }) => ($isDark ? '#434343' : '#f0f0f0')};
`;

/* ── Image upload (mirrors Items/ImageUploadField's visual language) ── */

export const ImagePreviewWrapper = styled.div<{ $isDark?: boolean }>`
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  border: 2px dashed ${({ $isDark }) => ($isDark ? '#434343' : '#d9d9d9')};
  background: ${({ $isDark }) => ($isDark ? '#1f1f1f' : '#fafafa')};
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:has(img) {
    border: none;
    background: none;
  }
`;

export const ImageUploadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 20px;
  border: none;
  background: #2d6cca;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  height: 28px;
  transition: background 0.2s;

  &:hover {
    background: #1e4d8f;
  }
`;

export const ImageEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 28px 16px;
  cursor: pointer;
  color: #bbb;
  width: 100%;
`;

export const ImageEmptyIcon = styled.span`
  font-size: 40px;
  color: #c0c0c0;
`;

export const ImageEmptyText = styled.span`
  font-size: 13px;
  color: #999;
`;

export const ImagePreviewImg = styled.img`
  width: 100%;
  height: 260px;
  object-fit: cover;
  display: block;
  background: #f5f5f5;
`;

export const ImageActionButtons = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
`;

export const ImageHint = styled.p`
  font-size: 11px;
  color: #666;
  margin: 6px 0 0;
`;

export const DeleteImageButton = styled(Button)`
  border-radius: 20px !important;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

/* ── Items picker (search + select-all + draggable selected pills) ── */

export const SuggestionsDropdown = styled.div<{ $isDark: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${({ $isDark }) => ($isDark ? '#1f1f1f' : '#fff')};
  border: 1.5px solid ${({ $isDark }) => ($isDark ? '#333' : '#f0f0f0')};
  border-radius: 14px;
  margin-top: 6px;
  z-index: 20;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
`;

export const SuggestionItem = styled.div<{ $isDark: boolean; $isSelectAll?: boolean }>`
  padding: 10px 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  transition: background 0.15s ease;
  ${({ $isSelectAll, $isDark }) =>
    $isSelectAll &&
    `
    font-weight: 700;
    border-bottom: 1px solid ${$isDark ? '#333' : '#f0f0f0'};
  `}

  &:hover {
    background: ${({ $isDark }) => ($isDark ? '#2a2a2a' : '#f0f5ff')};
  }

  &:first-child {
    border-radius: 14px 14px 0 0;
  }
  &:last-child {
    border-radius: 0 0 14px 14px;
  }
`;

export const DropdownLoadingWrap = styled.div`
  padding: 16px;
  text-align: center;
`;

export const DropdownEmptyMsg = styled.div`
  padding: 12px 14px;
  color: #999;
  font-size: 13px;
`;

export const SelectedItemText = styled.span`
  font-weight: 600;
`;

export const CheckIconWrap = styled.span`
  color: #52c41a;
  display: flex;
  align-items: center;
`;

export const SelectedItemsBox = styled.div<{ $isDark?: boolean }>`
  padding: 14px;
  border: 1.5px solid ${({ $isDark }) => ($isDark ? '#333' : '#e8edf5')};
  border-radius: 14px;
  margin-bottom: 8px;
  background: ${({ $isDark }) => ($isDark ? '#1a1a1a' : '#f7f9fc')};
`;

export const SelectedBoxLabel = styled.span<{ $isDark?: boolean }>`
  font-weight: 600;
  color: ${({ $isDark }) => ($isDark ? '#ccc' : '#333')};
`;

export const SelectedBoxEmpty = styled.span<{ $isDark?: boolean }>`
  display: block;
  margin-top: 8px;
  color: ${({ $isDark }) => ($isDark ? '#666' : '#888')};
`;

export const TagsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

// Draggable selected-item pill — same visual language as the plain tag pill
// used elsewhere, but with a drag handle since order matters for categories.
export const DraggableTagItem = styled.div<{ $isDragging?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 6px 4px 8px;
  border-radius: 20px;
  background: linear-gradient(135deg, #e8f0fe 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  cursor: grab;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.5 : 1)};

  &:active {
    cursor: grabbing;
  }
`;

export const TagGripHandle = styled.span`
  display: inline-flex;
  align-items: center;
  color: #7ea6e8;
  font-size: 10px;
`;

export const SelectedTagClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background: rgba(29, 78, 216, 0.12);
  color: #1d4ed8;
  cursor: pointer;
  font-size: 9px;
  padding: 0;
  transition: background 0.15s ease, color 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: #ef4444;
    color: #fff;
  }
`;

